import { useState, ChangeEvent, KeyboardEvent, FC, useEffect, useRef } from 'react';
import { cn } from '../../../utils/helpers';

interface Props {
  initialTags?: string[];
  onTagsChange: (tags: string[]) => void;
  className?: string;
  disabled?: boolean;
}

const TagsInput: FC<Props> = ({ initialTags = [], onTagsChange, className, disabled }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [tags, setTags] = useState<string[]>(initialTags);
  const [inputValue, setInputValue] = useState<string>('');

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleInputKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && inputValue.trim() !== '') {
      if (tags.includes(inputValue)) {
        return;
      }

      event.preventDefault();

      setTags((prevTags) => [...prevTags, inputValue.trim()]);

      setInputValue('');
    }
  };

  const handleTagRemove = (tag: string) => {
    setTags((prevTags) => prevTags.filter((t) => t !== tag));
  };

  useEffect(() => {
    onTagsChange(tags);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tags]);

  return (
    <div
      className={cn('p-4 rounded', 'border border-[#DADADA]', 'w-full', className)}
      onClick={() => inputRef?.current?.focus()}
    >
      {tags.map((tag, index) => (
        <span
          key={index}
          className={cn('text-xs inline-block', 'rounded-full p-2 bg-positive', 'mr-1 mb-1', 'shadow-sm')}
        >
          {tag}
          <button type="button" onClick={() => handleTagRemove(tag)} className="font-bold ml-2 mb-0.5">
            x
          </button>
        </span>
      ))}
      <input
        ref={inputRef}
        disabled={disabled}
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleInputKeyDown}
        placeholder="Tags"
        className={cn('outline-none', 'text-sm', 'w-full', 'disabled:bg-transparent')}
      />
    </div>
  );
};

export default TagsInput;
